<template>
    <span :class="['badge', badgeSizeClass]" :title="tooltipTitle" :style="badgeStyle">
        {{ status.name }}
    </span>
</template>

<script>
export default {
    props: {
        status: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: 'md' // Accepts 'sm', 'lg', or any other size indicators you want to use
        }
    },
    computed: {
        tooltipTitle() {
            return `Post in ${this.status.name} status`;
        },
        badgeStyle() {
            return {
                backgroundColor: this.status.color,
                color: this.status.text_color,
            };
        },
        badgeSizeClass() {
            return 'badge-' + this.size;
        }
    }
};
</script>
